
/**
 * className: text-center bg-danger text-white rounded
 */
import { defineComponent, ref, computed, onMounted, watch } from 'vue'
import moment from 'moment';
moment.locale("es");
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    props: {
        fechafin: {
            type: null,
            required: true,
            default: ''
        },
        className: {
            type: String,
            required: false,
            default: ''
        },
        classText: {
            type: String,
            required: false,
            default: 'text-black'
        },
        subtitle: {
            type: String,
            required: false,
            default: ''
        },
        dangerClass: {
            type: String,
            required: false,
            default: 'm-0 py-2'
        },
        dangerText: {
            type: String,
            required: false,
            default: 'h6 m-0 fw-bold text-fsecondary'
        }
    },
    emits: ["changeStatus"],
    setup(props, {emit}) {
        const { t } = useI18n();
        const displayDays = ref<any>(0);
        const displayHours = ref<any>(0);
        const displayMinutes = <any>ref(0);
        const displaySeconds = ref<any>(0);
        const loaded = ref(false);
        const expired = ref(false);

        const _seconds = 1000;
        const _minutes = computed(() => _seconds * 60);
        const _hours = computed(() => _minutes.value * 60);
        const _days = computed(() => _hours.value * 24);

        //console.log(moment(props.fechafin).format('YYYY-MM-DD HH:mm:ss'))
        const end = new Date(props.fechafin);
        //console.log(end)


        const parseDate = (dateString: string): Date | null => {
            const parsedDate = new Date(dateString);
            return isNaN(parsedDate.getTime()) ? null : parsedDate;
        };

        watch(() => props.fechafin, (newValue) => {
            console.log(parseDate(newValue));
        });


        const formatNum = (num: number) => (num < 10 ? '0' + num : num);

        const showRemaining = () => {
            const timer = setInterval(() => {
                const now = new Date();
                const distance = end.getTime() - now.getTime();

                if (distance < 0) {
                    clearInterval(timer);
                    expired.value = true;
                    loaded.value = true;
                    emit("changeStatus", expired.value)
                    return;
                }

                const days = Math.floor(distance / _days.value);
                const hours = Math.floor((distance % _days.value) / _hours.value);
                const minutes = Math.floor((distance % _hours.value) / _minutes.value);
                const seconds = Math.floor((distance % _minutes.value) / _seconds);

                displayMinutes.value = formatNum(minutes);
                displaySeconds.value = formatNum(seconds);
                displayHours.value = formatNum(hours);
                displayDays.value = formatNum(days);

                loaded.value = true;
            }, 100);
        };

        onMounted(()=>{
            showRemaining()
        })

        return {
            t,
            loaded,
            displaySeconds,
            displayMinutes,
            displayHours,
            displayDays,
            expired,
            end

        }


    },
})
